/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { Fragment } from 'react';
import { Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ProfileFields } from './profileFields';
import * as S from '../ClientProfile.styled';
import { CitizenshipData, ProfileUserData, Purpose } from '../ClientProfile';

import { CandidatePersonalInfoData } from 'api/models/response/TableInput';
import { RootState } from 'redux/store';

type GeneralInfoProps = {
    citizenshipData: CitizenshipData[] | null;
    mobile: boolean;
    personalInfoData: CandidatePersonalInfoData | null;
    purpose: Purpose | null;
    userData: ProfileUserData | null;
};

const GeneralInfo = ({
    userData,
    personalInfoData,
    citizenshipData,
    purpose,
    mobile,
}: GeneralInfoProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const purposeLabel =
        purpose?.purpose?.toLowerCase() ??
        t('notProvided', { lng: language, defaultValue: 'Not provided' });

    return (
        <>
            <S.InfoItem>
                <Tooltip title={t('visaPreference', { lng: language })}>
                    <S.Label>
                        {mobile
                            ? t('visa', { lng: language })
                            : t('visaPreference', { lng: language })}
                    </S.Label>
                </Tooltip>
                <Tooltip title={purposeLabel}>
                    <S.Info mobile={mobile}>{purposeLabel}</S.Info>
                </Tooltip>
            </S.InfoItem>
            <S.InfoItem>
                <Tooltip
                    title={
                        mobile
                            ? t('citizenship', { lng: language })
                            : t('citizenship', { lng: language })
                    }
                >
                    <S.Label>
                        {mobile
                            ? t('citizenship', { lng: language })
                            : t('citizenship', { lng: language })}
                    </S.Label>
                </Tooltip>
                <Tooltip
                    title={
                        citizenshipData &&
                        citizenshipData?.length > 0 &&
                        citizenshipData.map((item: any, index: number) => (
                            <p key={`${item?.country ?? ''}-${index}`}>
                                {item?.country} {index < citizenshipData.length - 1 && ', '}
                            </p>
                        ))
                    }
                >
                    <S.Info mobile={mobile}>
                        {citizenshipData &&
                            citizenshipData?.length > 0 &&
                            citizenshipData.map((item: any, index: number) => (
                                <Fragment key={`${item?.country ?? ''}-${index}`}>
                                    {item?.country}{' '}
                                    {index < citizenshipData.length - 1 && ', '}{' '}
                                </Fragment>
                            ))}
                    </S.Info>
                </Tooltip>
            </S.InfoItem>
            <S.InfoItem>
                <Tooltip title={t('firstName', { lng: language })}>
                    <S.Label>{t('firstName', { lng: language })}</S.Label>
                </Tooltip>
                <Tooltip title={userData?.firstname}>
                    <S.Info mobile={mobile}>{userData?.firstname}</S.Info>
                </Tooltip>
            </S.InfoItem>
            <S.InfoItem>
                <Tooltip title={t('lastName', { lng: language })}>
                    <S.Label>{t('lastName', { lng: language })}</S.Label>
                </Tooltip>
                <Tooltip title={userData?.lastname}>
                    <S.Info mobile={mobile}>{userData?.lastname}</S.Info>
                </Tooltip>
            </S.InfoItem>
            <S.InfoItem>
                <Tooltip title={t('email', { lng: language })}>
                    <S.Label>{t('email', { lng: language })}</S.Label>
                </Tooltip>
                <Tooltip title={userData?.email}>
                    <S.Info mobile={mobile}>{userData?.email}</S.Info>
                </Tooltip>
            </S.InfoItem>
            <S.InfoItem>
                <Tooltip title={t('phoneNumber', { lng: language })}>
                    <S.Label>
                        {mobile
                            ? t('phone', { lng: language })
                            : t('phoneNumber', { lng: language })}
                    </S.Label>
                </Tooltip>
                <Tooltip title={userData?.phone_number}>
                    <S.Info mobile={mobile}>{userData?.phone_number}</S.Info>
                </Tooltip>
            </S.InfoItem>
            <ProfileFields
                record={userData}
                keys={[
                    'middlename',
                    // 'file_number',
                    'language_setting',
                ]}
                mobile={mobile}
            />
        </>
    );
};

export default GeneralInfo;
